// extracted by mini-css-extract-plugin
export default {"messageText":"P8BXB_1lp45YoKxJ0U0w"};